import { render, staticRenderFns } from "./RankMonthly.vue?vue&type=template&id=5676a0f6&scoped=true"
import script from "./RankMonthly.vue?vue&type=script&lang=js"
export * from "./RankMonthly.vue?vue&type=script&lang=js"
import style0 from "./RankMonthly.vue?vue&type=style&index=0&id=5676a0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5676a0f6",
  null
  
)

export default component.exports